import { Route, Routes } from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./components/protectedRoute/protectedRoute";
import ComingSoon from "./pages/comingSoon/comingSoon";
import PageNotFound from "./pages/pageNotFound/pageNotFound";
import Tables from "./pages/tables/tables";

const protectedRoutes = [
  { path: "/", element: <ComingSoon title="Dashboard Page" /> },
  { path: "/leads/*", element: <Tables title="" /> },
  { path: "/zoom-calls", element: <ComingSoon title="Reports Page" /> },
  { path: "/matters/*", element: <ComingSoon title="Reports Page" /> },
  { path: "/pipeline", element: <ComingSoon title="Reports Page" /> },
  { path: "/calendar", element: <ComingSoon title="Reports Page" /> },
  { path: "/reports", element: <ComingSoon title="Reports Page" /> },
  { path: "/contacts", element: <ComingSoon title="Contacts Page" /> },
  { path: "/teams/*", element: <ComingSoon title="Teams Page" /> },
  { path: "/settings", element: <ComingSoon title="Settings Page" /> },
];

const App = () => {
  return (
    <div className="wrapper">
      <Routes>
        {protectedRoutes.map(({ path, element }, i) => {
          return <Route key={i} path={path} element={<ProtectedRoute>{element}</ProtectedRoute>} />;
        })}

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
};

export default App;
